"use client";

import { XMarkIcon } from "@heroicons/react/20/solid";
import { twMerge } from "tailwind-merge";

import { NormalText } from "@/components/text/NormalText";

const CancelLosses = [
  "Lose access to the harmony maker",
  "Lose access to your library",
];

export function ListLosses({ className }: { className?: string }) {
  return (
    <ul className={twMerge("space-y-2", className)}>
      {CancelLosses.map((loss) => (
        <li key={loss} className="flex items-center gap-x-2">
          <XMarkIcon
            className="h-5 w-5 flex-shrink-0 text-red-600"
            aria-hidden="true"
          />
          <NormalText elementType="span">{loss}</NormalText>
        </li>
      ))}
    </ul>
  );
}
